export const paths = {
  authentication: {
    welcome: '/',
    login: '/login',
    userDetails: '/userDetails',
  },
  journey: {
    input: '/journey-input',
    finish: '/journey-finish',
    concluded: '/journey-concluded',
  },
  home: '/home',
  dailySales: '/daily-sales',
  previousClosings: '/previous-closings',
  closureDetail: '/closure-detail/:id',
  collectionOrderDetail: '/collection-order-detail/:id',
  collectionOrder: {
    root: '/collection-order',
    newSale: '/collection-order-new-sale',
    tokenSent: '/collection-order-token-sent',
    achWaiting: '/collection-order-ach-waiting',
    achReceived: '/collection-order-ach-received',
  },
  user: {
    createUser: '/createUser',
    validateToken: '/validateToken',
    createPin: '/createPin',
    confirmPin: '/confirmPin',
    concluded: '/concluded',
    resetPassword: {
      informTaxId: '/resetPassword/informTaxId',
      validateToken: '/resetPassword/validateToken',
      createNewPin: '/resetPassword/createNewPin',
      confirmNewPin: '/resetPassword/confirmNewPin',
      resetSuccess: '/resetPassword/resetSuccess',
    },
  },
} as const
